<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">特步</div>
          <div class="contentBottom">
            <div>国产运动品牌智慧门店新范式</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>-->
    <!-- start -->
    <!-- start -->
    <div class="titleBox1">
      <div class="anliTitle">项目背景</div>
      <div class="lineCss1"></div>
    </div>
    <div class="productParent marginTop109">
      <div class="productLeft">
        <div class="productRightText paddingRight">
          作为老牌国产运动品牌，特步想要在阿里新零售战略中做“第一个吃螃蟹的人”，智慧门店从0到1的搭建迫在眉睫，痛点如下：
         <br/>a、线下线上原属完全分离的两个渠道，需要从0搭建连接；
         <br/>b、线下实体店铺日渐丧失吸引力，需要有力的引流策略。
        </div>
      </div>
      <div class="productRight">
        <img v-lazy="productLeft1" class="rightImgCss">
      </div>
    </div>

    <!-- end -->

    <div class="grayBox">
      <div class="titleBox" style="margin-top:0;">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div
        class="grayBoxText"
      >数拓根据特步顾客行为旅程，划分店外、进店、选购、试穿、买单五个场景。针对各场景需求，采用智能交互屏，通过线上线下渠道打通，实现全流程智能化消费体验。同时在顾客交互过程中，通过智能外设留存顾客属性数据、交互行为数据等，为特步提供营销策划指导。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img v-lazy="detailListIcon1" alt>
          <div class="detailBoxTitle">数拓智屏OS</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon4" alt>
          <div class="detailBoxTitle">天猫数据对接</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon5" alt>
          <div class="detailBoxTitle">场景app</div>
        </div>
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">场景解析</div>
      <div class="lineCss"></div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">店外-LED屏</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >位于室外广场的LED屏，是辐射人群最广的显示器。通过数拓智屏控制系统，可以实现轮播、插播、定时播放等多种方式，展示品牌活动信息，从视觉上吸引路人，实现初步引流。</div>
      </div>

      <div class="bottomRight">
        <img v-lazy="wanDaContent2" alt>
      </div>
    </div>
    <!-- <div class="leftYellowParent">
      <div class="leftYellow"></div>
      <div class="bottomParent">
        <div class="bottomLeft">
          <img v-lazy="wanDaContent2" alt>
        </div>
        <div class="bottomRight">
          <div class="bottomRightTitle">店外-LED屏</div>
          <div
            class="bottomRightText"
          >位于室外广场的LED屏，是辐射人群最广的显示器。通过数拓智屏控制系统，可以实现轮播、插播、定时播放等多种方式，展示品牌活动信息，从视觉上吸引路人，实现初步引流。</div>
        </div>
      </div>
    </div> -->
    <!-- <div class="gapCss">进店-微笑领红包+妥妥抓娃娃</div> -->
    <div class="bottomParent">
      <div class="bottomLeft">
        <img v-lazy="wanDaContent4" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">微笑领红包</div>
        <div
          class="bottomRightText"
        >顾客可以在店前，通过微笑评分测试，领取门店优惠券。在游戏过程中，综合传感器可以进行人脸采集匹配天猫账号，并且在领券环节引导顾客一键入会。我们通过进店发券这一购物场景，为门店引流，并且帮助特步完善用户画像。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">妥妥抓娃娃</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >为陪同他人购物的“无聊”顾客提供娱乐，聚客引流渲染气氛。我们通过手机、大屏的交互，以视频方式关联远程娃娃机，发放优惠券。在交互过程中，帮助特步采集人脸信息，并发放优惠权益提升销量转化。</div>
      </div>

      <div class="bottomRight">
        <img v-lazy="wanDaContent3" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img v-lazy="teBuContent5" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">选购-云货架</div>
        <div
          class="bottomRightText"
        >以打通线上线下为目标，我们通过关联天猫线上商品信息，展示线上商品。内置综合传感器人脸识别，实现精准化的爆品推荐。同时，可识别商品条码，自动展示库存信息。帮助特步实现无人化精准导购，自助式商品查询，节省人力的同时提升爆品成交率。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">试衣-社交试衣镜</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >我们在镜面试衣镜中内置屏幕、摄像头和传感器，顾客可以录制试衣视频，两组同时放映进行对比，顾客可通过扫码获取视频，进行线上分享，店铺也可精选视频在店内放映。帮助特步提升试衣体验，减轻试衣间压力；并融入社交，打造线上线下的全面秀场，引发顾客自发的宣传营销。</div>
      </div>

      <div class="bottomRight">
        <img v-lazy="teBuContent6" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img v-lazy="teBuContent7" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">买单-智能优惠购</div>
        <div
          class="bottomRightText"
        >收银台后方的大幅拼接屏，我们将其与POS系统打通，无人时播放品牌宣传视频，有人买单时，一经扫码，屏幕即刻弹出推荐搭配优惠单品。在顾客离店前的最后一秒，激发购物欲，提升客单价。</div>
      </div>
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/teBuTop.png";
import productLeft1 from "@/assets/images/teBuContent1.png";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/teBuContent4.png";
import wanDaContent4 from "@/assets/images/teBuContent3.png";
import detailListIcon1 from "@/assets/images/teBuIcon1.png";
import detailListIcon2 from "@/assets/images/teBuIcon2.png";
import detailListIcon3 from "@/assets/images/teBuIcon3.png";
import detailListIcon4 from "@/assets/images/teBuIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/teBuContent5.png";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import Bread from "@/components/bread.vue";

export default {
  name: "TeBuCase",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "特步"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 180px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 77px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
  margin-bottom: 40px;
  
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
  width: 50%;
  margin: auto;
  text-align: center;
  margin-top: 80px;
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 40%;
  padding-left: 10%;
  float: left;
}

.productLeft img {
  width: 98%;
  max-width: 542px;
}

.productRight {
  width: 46%;
  padding-left: 2%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin-top: 3px;
}

.marginTop109 {
  margin-top: 60px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 194px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 50%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
  margin-left: 15%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  padding-right: 10%;
  margin-left: 15%;
}
.bottomRightTitleTwo {
  /* text-align: center; */
  margin-left: 15%;
}
.bottomRightTextTwo {
  width: 70%;
  margin-top: 6%;
  margin-left: 15%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  /* max-width: 618px; */
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
/* 左边 left  start */
.leftYellowParent {
  position: relative;
}
.leftYellow {
  position: absolute;
  left: 0;
  top: 170px;
  width: 12.5%;
  height: 45px;
  background: rgba(252, 200, 0, 1);
}
/* 左边 left  end */
@media screen and (max-width: 1200px) {
  .lineCss1 {
     margin: auto;
    margin-top: 10px;
    margin-bottom: 20px;
   
  }
  .productRightText {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/teBuCase.vue